export default {
  'memberPoint.title': '會員點數',
  'memberPoint.loyalty.title': '活動點數',
  'memberPoint.loyalty.name': '活動名稱',
  'memberPoint.detail': '詳情',
  'memberPoint.store': '門市',
  'memberPoint.point': '點數',
  'memberPoint.source': '來源',
  'memberPoint.update_time': '獲點時間',
  'memberPoint.deduct_time': '扣點時間',
  'memberPoint.expired_at': '到期時間',
  'memberPoint.note': '備註',
  'memberPoint.details': '說明',
  'memberPoint.current_point': '目前累積點數',
  'memberPoint.issue_date': '發點日期',
  'memberPoint.date': '日期區間',
  'memberPoint.expired': '即將到期',
  'memberPoint.case': '事件',
  'memberPoint.receiver': '收禮者',
  'memberPoint.transfer': '轉贈者',
  'memberPoint.record': '點數紀錄',
  'memberPoint.benefit': '點數權益',
} as Record<string, string>;
